import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import DocumentsLegacyRedux from '../../components/Documents';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import { deleteFaqsNotesDocuments } from 'src/store/actions/faqsNotesDocuments';
import { selectDocuments } from 'src/store/selectors/faqsNotesDocuments';
import { setSearch, clearSearch } from 'src/store/actions/search';
import { DocumentFormData } from 'src/utils/S3UploadDocumentsUtility';
import {
  useDocumentSave,
  UseDocumentSaveReturn,
} from 'src/pages/SharedPageCustomHooks/UseDocumentSave/useDocumentSave';

interface Asset {
  id: string;
  name: string;
}

interface AssetDocumentsProps {
  asset: Asset;
}

// Functional component
const AssetDocuments = ({ asset }: AssetDocumentsProps) => {
  const user = useSelector(selectAuthenticatedUser);
  const documents = useSelector(selectDocuments);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearSearch());
  }, [dispatch]);

  const { saveDocument }: UseDocumentSaveReturn = useDocumentSave({
    customErrorMessage:
      'Failed to upload this asset document. Please try again or contact Juniper support if the issue persists.',
  });

  const onSave = async (document: DocumentFormData): Promise<void> => {
    await saveDocument(document, asset.id, user.id);
  };

  const onDeleteFaqsNotesDocuments = (document: DocumentFormData): void => {
    document.Type = 'DOCUMENT';
    dispatch(deleteFaqsNotesDocuments(document));
  };

  return (
    <DocumentsLegacyRedux
      breadcrumb={asset.name}
      documents={documents}
      onSaveDocument={(document: DocumentFormData) => onSave(document)}
      onDeleteDocument={(document: any) => onDeleteFaqsNotesDocuments(document)}
      onSearch={(e: any) =>
        dispatch(setSearch({ documents: e.target.value.trim() }))
      }
      labelName={'Manuals & Documents'}
    />
  );
};

export default AssetDocuments;
